import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from "react-i18next";

import { ar, en } from './locales';

const options = {
  interpolation: {
    escapeValue: false,
  },

  debug: false,

  lng: 'ar',

  resources: {
    ar: {
      common: ar['ar'],
    },
    en: {
      common: en['en'],
    }
  },

  fallbackLng: 'ar',

  ns: ['common'],

  defaultNS: 'common',

  react: {
    // wait: false,
    // bindI18n: 'languageChanged loaded',
    // bindStore: 'added removed',
    // nsMode: 'default',
    // useSuspense:true,

    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    useSuspense: true,
  },
};

i18n
  .use(initReactI18next)
  // .use(LanguageDetector)
  .init(options);

export default i18n;